import request from '@/common/request'

class NaturezaService {
  buscarTodas() {
    return request.get('/naturezas')
  }

  buscarPeloId(naturezaId) {
    return request.get(`/naturezas/${naturezaId}`)
  }

  buscarTipoMovimentoEntrada() {
    return request.get('/naturezas?tipoMovimento=ENTRADA')
  }

  buscarTipoMovimentoSaida() {
    return request.get('/naturezas?tipoMovimento=SAIDA')
  }

  create(data) {
    return request.post('/naturezas', data)
  }

  update(id, data) {
    return request.patch(`/naturezas/${id}`, data)
  }

  deleteById(id) {
    return request.delete(`/naturezas/${id}`)
  }
}

export default new NaturezaService()
